import React from "react";
import styles from "./LoginPage.module.scss";
import LoginSignUp from "../LoginSignUp";
import loginImage from "../../../Images/LoginPageImage-removebg-preview.png";
function LoginPage() {
  return (
    <div className={styles.loginPage_container}>
      <LoginSignUp />
      <div className={styles.login_image_container}>
        <img src={loginImage} alt="image" className={styles.login_image} />
      </div>
    </div>
  );
}

export default LoginPage;
